import React, {useState} from 'react';
import Accordion from '@Components/Accordion';
import {injectIntl} from 'react-intl';
import stringSanitizer from 'stringSanitizer';

const AccordionWrapper = ({state, intl}) => {
  const [activeAcc, setActiveAcc] = useState('');
  const renderElements = () => {
    if (state && state.length) {
      return state.map((value, i) => {
        const items = value.jobs.map((item, key) => (
          <li key={key}>
            <a href={`/salary/${stringSanitizer(item)}-salaries/`} key={`${value.category}-${item}`}>{item}</a>
          </li>
        ));

        return (
          <li className="link-list__item" key={value.category}>
            <Accordion title={value.category} setActiveAcc={setActiveAcc} index={i} handleCollapse={activeAcc !== i}>
              <ul className="job-category-list">
                {items}
              </ul>
            </Accordion>
          </li>
        );
      });
    }

    return '';
  };

  return (
    <ul className="link-list">
      {renderElements()}
    </ul>
  );
};

export default injectIntl(AccordionWrapper);
